// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__3Lr1E","balanceDisclaimer":"posDashboard_balanceDisclaimer__2LUar"};